module.exports = __webpack_public_path__ + "static/media/padmaster_logo_web.801cce4c.svg";